<table class="table table-hover table-condensed table-sm" [style.font-size.rem]="produtoDescrFontSize">
  <!-- <thead class="table-head">
  <tr>
    <th></th>
    <th>Produto</th>
    <<th>Cor</th>
    <th>Estampa</th>
    <th>Tamanho</th>
    <th class="responsive-table-elements"></th>
    <th
      class="responsive-table-elements"
      *ngIf="mostraPreco"
    ></th>
    <th
      class="responsive-table-elements"
      *ngIf="SITE.mostraEstoqueDigitacao"
    ></th>
    <th *ngIf="pedido">Quant.</th>
    <<th *ngIf="mostraPreco">R$ Preço</th>
  </tr>
</thead> -->
  <tbody>
    <tr *ngFor="let product of products" class="produto">
      <!-- <td *ngIf="product.quantidade && product.quantidade !== null">
        <div
          class="product-quantity-box"
          [style.backgroundColor]="site.backgroundColorSliderSuperior"
        >
          <div class="product-quantity">
            <span>{{product.quantidade}}</span>
          </div>
        </div>
      </td> -->
      <td class="img-product">
        <a href="javascript:void(0);" tabindex="-1" (click)="callPhotos(product.id, product.corcod)">
          <div *ngIf="product.imagem; else elseBlockImg">
            <div *ngIf="product.quantidade && product.quantidade !== null" class="product-quantity-box"
              [style.backgroundColor]="site.backgroundColorSliderSuperior">
              <div class="product-quantity">
                <span>{{ product.quantidade }}</span>
              </div>
            </div>
            <img style="max-width: 48px; max-height: 48px" src="{{ API_IMAGENS_PRODUTOS }}{{ product.imagem }}"
              class="img-fluid" />
          </div>
          <ng-template #elseBlockImg>
            <div *ngIf="product.quantidade && product.quantidade !== null" class="product-quantity-box"
              [style.backgroundColor]="site.backgroundColorSliderSuperior">
              <div class="product-quantity">
                <span>{{ product.quantidade }}</span>
              </div>
              <img style="max-width: 48px; max-height: 48px" src="assets/no-product-image.jpg" class="img-fluid" />
            </div>
          </ng-template>
        </a>
      </td>
      <td class="refDescr">
        <a href="javascript:void(0);" tabindex="-1" (click)="callPhotos(product.id, product.corcod)">
          <span class="title-description">
            {{ product.descricao }}
          </span>
        </a>
        <div>
          <span class="responsive-table-elements-reverse ref">
            <span class="ref-label-grade2">
              REF:
            </span>
            {{ product.referencia }}
          </span>
          <!-- <br /> -->
          <span *ngIf="product.preco && mostraPreco" class="responsive-table-elements-reverse preco" i18n>
            <span class="price-label-grade2">
              PR:
            </span>
            R${{ product.preco | currency : "BRL" : "" }}</span>
        </div>
        <div *ngIf="!product.estoque && SITE.mostraDisponivelCatalogo">
          <span class="badge badge-secondary" style="font-size: 0.7rem">
            Indisponível
          </span>
        </div>
      </td>
      <td class="responsive-table-elements">
        <span class="ref">
          <span class="ref-label-grade2">
            REF:
          </span>
          {{ product.referencia }} </span>
      </td>
      <td class="responsive-table-elements" *ngIf="mostraPreco">
        <div *ngIf="product.preco">
          <span class="preco">
            <span class="price-label-grade2 ">
              {{product.precopromocional ? 'De:' : "Preço:"}}
            </span>
            <span class="{{product.precopromocional ? 'preco-cancelado' : ''}}"i18n>
              R${{ getPrice(product) | currency : "BRL" : "" }}
            </span>
          </span>
          <div *ngIf="product.precopromocional">

            <span class="money1">Por: R${{
              product.precopromocional | currency : "BRL" : ""
              }}</span>
          </div>
        </div>
      </td>
      <!-- <td class="responsive-table-elements">{{ product.cordescr }}</td>
      <td class="responsive-table-elements">{{ product.estampadescr }}</td>
      <td class="responsive-table-elements">{{ product.tamanho }}</td> -->
      <td class="responsive-table-elements" *ngIf="SITE.mostraEstoqueDigitacao" style="font-weight: bold">
        {{
        this.SITE.quantidadeMaximaGrade > 0 &&
        product.estoque >= this.SITE.quantidadeMaximaGrade
        ? "Estoque: " + this.SITE.quantidadeMaximaGrade + "*"
        : "Estoque: " + product.estoque
        }}
      </td>
      <td *ngIf="pedido">
        <div>
          <div *ngIf="
              !pedido.tipo.validaEstoque ||
              (pedido.tipo.validaEstoque && product.estoque > 0)
            " class="form-group mb-0 text-center" [style.max-width]="'270px'">
            <!-- <input
          step="{{ product.multiplo }}"
          max="{{ product.quantidademaximadisponivelgrade }}"
          type="number"
          min="0"
          (blur)="addItemCart($event)"
          class="form-control inputGrade"
          [value]="product.quantidade === null ? 0 : product.quantidade"
        /> -->
            <app-product-quantity-input *ngIf="product.preco" #productQuantityInput [product]="product"
              [produtoDescrHeight]="produtoDescrHeight" (onAdd)="addCart($event, product)">
            </app-product-quantity-input>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<div class="modal fade m-4 mt-5 productDetails" id="productDetails" tabindex="-1" role="dialog"
  aria-labelledby="productDetails" aria-hidden="true">
  <div class="modal-dialog" id="productDetailsModalDialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mt-1 mb-1">
          <div class="col-12 pl-0 pr-0">
            <app-page-produto *ngIf="showProduct" [productId]="selectedProduct"
              (updateQuantity)="updateQuantity($event)" (redirectTo)="redirectTo2($event)"></app-page-produto>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <td *ngIf="mostraPreco">
    <div *ngIf="product.precoPromocional; else elseBlockPreco">
      <span class="moneyOff" style="font-size: 0.8rem"
        >R${{ product.preco | currency : "BRL" : "" }}</span
      >
      <span class="money1 ml-1" style="font-size: 0.8rem"
        >R${{
          product.precoPromocional | currency : "BRL" : ""
        }}</span
      >
    </div>
    <ng-template #elseBlockPreco>
      <div *ngIf="product.preco">
        <span class="money" style="font-size: 0.8rem"
          >R${{ product.preco | currency : "BRL" : "" }}</span
        >
      </div>
    </ng-template>
    <div class="moneyImposto">
      {{
        calculaImposto(product.imposto, product.precopromocional, product.preco)
      }}
    </div>
    <div *ngIf="product.precosugerido" tooltip="Preço sugerido">
      <span class="badge badge-primary"
        >* R${{
          product.precosugerido | currency : "BRL" : ""
        }}</span
      >
    </div>
  </td> -->